import React from "react"
import { create } from "zustand"

export type ToastPosition = "top" | "center" | "bottom"
interface ToastState {
  content: string | React.ReactNode | null
  position: ToastPosition
  isVisible: boolean
  showToast: (
    position: ToastPosition,
    content: string | React.ReactNode,
    timeout?: number,
  ) => void
  hideToast: () => void
  timeoutId: NodeJS.Timeout | null
}

// 토스트 제한 시간
const DEFAULT_TIME_OUT_IN_MS = 3_000 // 3초

export const useToastStore = create<ToastState>((set, get) => ({
  content: null,
  position: "bottom",
  isVisible: false,
  timeoutId: null,
  showToast: (position, content, timeout) => {
    const currentTimeout = get().timeoutId
    if (currentTimeout) clearTimeout(currentTimeout)

    const newTimeout = setTimeout(
      () => set({ isVisible: false, timeoutId: null }),
      timeout ?? DEFAULT_TIME_OUT_IN_MS,
    )

    set({ position, content, isVisible: true, timeoutId: newTimeout })
  },
  hideToast: () => {
    const currentTimeout = get().timeoutId
    if (currentTimeout) clearTimeout(currentTimeout)
    set({ content: null, isVisible: false, timeoutId: null })
  },
}))
